import request from "../../tools/http";
import Types from "../../../typings/interface";
export default {
  // 支付
  payMoney(data: any): Promise<any> {
    return request({
      method: "post",
      url: "/pay/prePay",
      data
    });
  }
};
